import { z } from 'zod';
import { FieldSchema } from '../common';
import { InitialUIElement } from '../initial-ui-element';

export const MCC_PICKER_FIELD_ELEMENT_TYPE = 'mccpickerfield' as const;
export const MCCPickerFieldElementType = z.literal(MCC_PICKER_FIELD_ELEMENT_TYPE);

export const MCCPickerFieldParamsSchema = FieldSchema.extend({
  optionNotFoundText: z.string().optional(),
});

export type TMCCPickerFieldParams = z.infer<typeof MCCPickerFieldParamsSchema>;

export const MCCPickerFieldElementSchema = InitialUIElement.extend({
  element: MCCPickerFieldElementType,
  params: MCCPickerFieldParamsSchema,
  valueDestination: z.string(),
});
